<!-- 推2返1 规则说明 -->
<template>
  <div class="rule-page">
    <div class="rule-header">
      <h1 class="rule-title">规则说明</h1>
      <p class="rule-subtitle">推2返1 玩法与奖励规则</p>
    </div>

    <div class="rule-body">
      <section class="rule-section">
        <h3 class="section-title">
          <span class="section-icon">🎁</span>
          1. 基础产品与赠券
        </h3>
        <p class="section-text">
          购买「全球梦」酱香酒，单价 <strong class="highlight">899元/瓶</strong>。
        </p>
        <p class="section-text">
          每购买一单，系统即赠送 <strong class="highlight">2 张 500元广告券</strong>（总价值1000元）。
        </p>
      </section>

      <section class="rule-section">
        <h3 class="section-title">
          <span class="section-icon">🔓</span>
          2. 广告券解锁（两种方式）
        </h3>
        <ul class="section-list">
          <li>
            <strong>直推解锁：</strong>每直推 1 名用户下单，即可立即解锁 1 张 500元广告券，直接提现至余额。
          </li>
          <li>
            <strong>打卡解锁：</strong>连续 15 天完成每日 10 条广告观看任务，即可解锁 1 张 500元券。
            <span class="section-tip">注：打卡必须连续，中断则需重新计算。</span>
          </li>
        </ul>
      </section>

      <section class="rule-section">
        <h3 class="section-title">
          <span class="section-icon">📈</span>
          3. 级差制网体奖励
        </h3>
        <p class="section-text section-text--small">
          推广团队（网体）产生订单时，按等级拿级差收益（金豆）：
        </p>
        <ul class="section-list section-list--compact">
          <li>区代（直推2单）：10 金豆/单</li>
          <li>市代（直推2区代）：15 金豆/单</li>
          <li>省代（直推2市代）：20 金豆/单</li>
        </ul>
      </section>

      <section class="rule-section">
        <h3 class="section-title">
          <span class="section-icon">👑</span>
          4. 总代分红与循环冲关
        </h3>
        <p class="section-text section-text--small">
          当网体累计达 100 单或直推 3 个省代时，升级为<strong>总代</strong>并出局进入分红池：
        </p>
        <ul class="section-list">
          <li>
            <strong>全网分红：</strong>提取全网订单总额的 12% 作为分红池（30% 平分，70% 加权）。
          </li>
          <li>
            <strong>出局收益：</strong>保留直推省代网体 5金豆/单 的级差收益，外加个人网体额外 3% 奖励。
          </li>
          <li>
            <strong>循环冲关：</strong>出局后可重新入局发展新网体，分红加权系数累加。
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushTwoReturnOneRule',
}
</script>

<style scoped>
.rule-page {
  min-height: 100vh;
  background: #f8fafc;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
}

.rule-header {
  padding: 20px 16px 16px;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
}

.rule-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.rule-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

.rule-body {
  padding: 16px;
}

.rule-section {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.rule-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
  line-height: 1.4;
}

.section-icon {
  font-size: 16px;
  line-height: 1;
}

.section-text {
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
  margin-bottom: 8px;
}

.section-text:last-child {
  margin-bottom: 0;
}

.section-text--small {
  font-size: 13px;
}

.highlight {
  color: #2563eb;
  font-weight: 600;
}

.section-list {
  padding-left: 18px;
  font-size: 13px;
  color: #475569;
  line-height: 1.7;
}

.section-list li {
  margin-bottom: 8px;
}

.section-list li:last-child {
  margin-bottom: 0;
}

.section-list--compact li {
  margin-bottom: 4px;
}

.section-tip {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #f43f5e;
  line-height: 1.5;
}
</style>
